import React, { useState, useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../Footer/Footer";
import BackgroundAnimated from "../BackgroundAnimated/BackgroundAnimated";
import LayoutMobile from "./LayoutMobile";
import { useContext } from "react";
import AuthContext from "../../context/AuthContext";

function Layout() {
  const [isSmallScreen, setIsSmallScreen] = useState(
    () => window.innerWidth <= 835
  );
  const { state } = useContext(AuthContext);

  useEffect(() => {
    const handleResize = () => {
      const sizeWidth = window.innerWidth <= 835;
      setIsSmallScreen(sizeWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!state.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isSmallScreen) {
    return <LayoutMobile />;
  } else {
    return (
      <div className="layout relative h-full overflow-hidden ">
        <BackgroundAnimated />
        <div className="flex h-full contentLayout">
          <div className="sidebar h-auto z-10">
            <Sidebar />
          </div>

          <div className="main flex-grow mt-8">
            <div className="flex flex-col lg:justify-between items-center overflow-auto h-full">
              <Outlet />
              <Footer />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Layout;


